import SignupForm from './container'

export default SignupForm
